import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import ENV_VARS from '@/config'
import useRole from '@/hooks/use-role'
import useSessionComplete from '@/hooks/use-session-complete'
import { makeMainLayout } from '@/layouts/main'
import { useDSLogin } from '@/features/Auth/Context/ds-login-provider'
import PostAListing from '@/features/post-a-listing'
import Head from '@/components/head'

const { DASHBOARD_URL } = ENV_VARS
const PostListing = () => {
  const { t } = useTranslation()
  const { afterLoginRef } = useDSLogin()
  const metaTitle = t('pricing:Landlords Create Unlimited Listings | liv.rent')
  const metaDescription = t(
    `pricing:Post your first rental listing today. Take advantage of liv.rent's all-in-one tenant credit check and rental management & marketing tools.`
  )
  const role = useRole()
  const isLoggedIn = useSessionComplete()
  const isLandlord = role === 'landlord'

  useEffect(() => {
    if (afterLoginRef.current) return
    if (isLandlord) {
      window.location.href = `${DASHBOARD_URL}/listing/create`
    } else if (isLoggedIn) {
      window.location.href = DASHBOARD_URL
    }
  }, [isLandlord, isLoggedIn])

  return (
    <>
      <Head
        title={metaTitle}
        description={metaDescription}
        path="/post-a-listing"
      />
      <PostAListing />
    </>
  )
}
export const getStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['translation', 'pricing']))
    }
  }
}

const headerConfig = {
  visible: false
}

const footerConfig = {
  visible: false
}

PostListing.Layout = makeMainLayout({ headerConfig, footerConfig })
export default PostListing
